(function () {
  'use strict';

  if (typeof document === 'undefined') return;

  var HOSTS = '[data-broek-b2g1-cro],[data-broek-cart-page-offer]';
  var FALLBACK_LABEL = 'Items added';

  function countLabel(key, fallback) {
    fallback = fallback || FALLBACK_LABEL;
    var node = document.querySelector('[data-broek-offer-config]');
    if (!node) return fallback;
    try {
      var cfg = JSON.parse(node.textContent);
      return (cfg && cfg.strings && cfg.strings[key || "items_added"]) || fallback;
    } catch (error) {
      return fallback;
    }
  }

  function offerCounts(host) {
    try {
      var state = JSON.parse(host.getAttribute('data-render-signature') || '{}').s;
      if (!state) return null;
      var paid = Number(state.paidQty);
      var free = Number(state.claimedFree);
      if (!Number.isFinite(paid) || !Number.isFinite(free) || paid < 0 || free < 0) return null;
      return { paid: Math.floor(paid), free: Math.floor(free) };
    } catch (error) {
      return null;
    }
  }

  function directChild(host, selector) {
    var el = host.querySelector(selector);
    return el && el.parentElement === host ? el : null;
  }

  function decorate(host) {
    if (!host.classList.contains('broek-b2g1-cart-cro')) return;
    if (host.querySelector('.broek-offer-box')) return;
    if (!directChild(host, '.broek-offer-heading')) return;

    var kind = host.getAttribute('data-cart-kind') || '';
    var step = Number(host.getAttribute('data-offer-items')) || 0;
    var total = Number(host.getAttribute('data-offer-target')) || 0;
    var counted = total > 0 && kind !== 'ended' && kind !== 'unavailable';
    var percent = counted ? Math.round((step / total) * 100) : 0;
    var quantities = offerCounts(host);
    var paidLabel = countLabel("paid_title", "Paid items");
    var freeLabel = countLabel("free_units", "__COUNT__ FREE").replace("__COUNT__", "").trim();

    var box = document.createElement('div');
    box.className = 'broek-offer-box';

    var copy = document.createElement('div');
    copy.className = 'broek-offer-copy';
    ['.broek-offer-eyebrow', '.broek-offer-heading', '.broek-offer-detail'].forEach(function (selector) {
      var el = directChild(host, selector);
      if (el) copy.appendChild(el);
    });
    box.appendChild(copy);

    if (counted && quantities) {
      var count = document.createElement('div');
      count.className = 'broek-offer-count';
      count.setAttribute('aria-hidden', 'true');
      var value = document.createElement('strong');
      value.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:8px;font-size:16px;line-height:1.1';
      [quantities.paid, quantities.free].forEach(function (quantity) {
        var number = document.createElement('span');
        number.textContent = String(quantity);
        value.appendChild(number);
      });
      var caption = document.createElement('small');
      caption.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:8px;white-space:nowrap;font-size:9px;line-height:1.25';
      [paidLabel, freeLabel].forEach(function (label) {
        var text = document.createElement('span');
        text.textContent = label;
        caption.appendChild(text);
      });
      count.appendChild(value);
      count.appendChild(caption);
      box.appendChild(count);
    }

    var track = directChild(host, '.broek-offer-track');
    if (track) {
      if (counted) {
        var fill = track.firstElementChild;
        if (fill) fill.style.width = percent + '%';
        track.setAttribute('aria-valuenow', String(percent));
        if (quantities) track.setAttribute('aria-valuetext', quantities.paid + ' ' + paidLabel + ', ' + quantities.free + ' ' + freeLabel);
        else track.removeAttribute('aria-valuetext');
      }
      box.appendChild(track);
    }

    host.insertBefore(box, host.firstChild);
    host.setAttribute('data-broek-step', String(step));
  }

  function run() {
    var hosts = document.querySelectorAll(HOSTS);
    for (var i = 0; i < hosts.length; i++) decorate(hosts[i]);
  }

  document.addEventListener('broek:offer-state', run);
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('broek:cart-drawer-refreshed', run);
  run();
  setTimeout(run, 300);
})();
